import styles from "./Errors.module.css";
import { Btn } from "@/components/Generics/Btn";
import { SmallText } from "@/components/Generics/SmallText";
import { Logo } from "@/components/Generics/Logo";
import { Title } from "@/components/Generics/Title";

export const ErrorFallback = ({ reset }: { reset?: () => void }) => (
  <div className={styles.container}>
    <div className={styles.error}>
      <Logo type="white" />
      <Title>Something went wrong.</Title>
      <Btn action={reset ?? (() => {})} children="Try Again" />
      <SmallText>
        If the problem persists, please refresh the browser window.
      </SmallText>
    </div>
  </div>
);
